import React from 'react'
import { CurrencyText } from '../../../Global'

export const TableDataCellRevenue = ({ dataValue }: { dataValue?: number }) => {
  return <CurrencyText value={Number(dataValue)} />
}
